export default (strings, ...rest) => [...strings, ...rest].join('\n');
